import VueTypes from 'vue-types'

export default {
  name: 'lx-pacman-loader-new',
}
